import { render, staticRenderFns } from "./AccountsPage.vue?vue&type=template&id=469db702&scoped=true"
import script from "./AccountsPage.vue?vue&type=script&lang=js"
export * from "./AccountsPage.vue?vue&type=script&lang=js"
import style0 from "./AccountsPage.vue?vue&type=style&index=0&id=469db702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469db702",
  null
  
)

export default component.exports